import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AccessBlockerService } from 'src/shared/services/access-blocker.service';
import { PageHeaderService } from 'src/shared/services/page-header.service';
import { HelperComponent } from 'src/shared/helper-components/helper/helper.component';

import { AccessBlockerComponent } from '../access-blocker/access-blocker.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-page-header',
    templateUrl: './page-header.component.html',
    styleUrls: ['./page-header.component.less'],
    imports: [
    HelperComponent,
    AccessBlockerComponent,
    TranslateModule
]
})

export class PageHeaderComponent implements OnInit {
  @Input() parentTitle: string;
  @Input() pageTitle: string;
  @Input() subRoute: string;

  constructor(private pageHeaderService: PageHeaderService,
    private router: Router, private accessBlockerService: AccessBlockerService) {
  }

  ngOnInit(): void {
    this.currentRoute = this.router.url;

    this.router.events.subscribe(() => {
      this.currentRoute = this.router.url;
    });

    //faz a requisição para verificar se está inadimplente
    this.accessBlockerService.getPaymentStatus(this.company).subscribe({
      next: (res: any) => {
        /** Lógica para exibir o banner de inadimplência **/
        const daysSinceLastPayment =
          res?.data?.paymentStatus?.[0]?.daysSinceLastPayment;

        /** Lógica para exibir o banner após passar 32 dias desde o dia do ultimo pagamento **/
        if (daysSinceLastPayment >= 32) {
          /** Exibe o o banner **/
          this.showBlockerAlert = true;

          /** Chacoalha o banner após eventos  **/
          document.addEventListener('click', () =>
            this.accessBlockerService.shakeCard(),
          );
          window.addEventListener('scroll', () =>
            this.accessBlockerService.shakeCard(),
          );
          window.addEventListener('keydown', () =>
            this.accessBlockerService.shakeCard(),
          );
        }
      },
    });
  }

  /** Propriedade que manipula quando o banner será exibido **/
  public showBlockerAlert = false;

  /** Propriedade que armazena a rota aual **/
  public currentRoute: string = '';

  company = localStorage.getItem('lastCompanySelected')
    ? localStorage.getItem('lastCompanySelected')
    : null;

  /** Propriedade utilizada para exibir a mensagem com a contagem de dias até o bloqueio total do sistema **/
  public daysSinceLastPaymentMessage: string;
  openSidebar(): void {
    this.pageHeaderService.openSideBar.emit(true);
  }

  openSubMenu(): void {
    this.pageHeaderService.openSubMenu.emit(this.parentTitle);
  }

  goToHome(): void {
    this.router.navigate(['/map']);
  }
}
